import React, { Fragment } from 'react'
import BaseListing from './BaseListing'

import '@loyal_template/benefits.css'

import { Filter } from '../Filter'
import { Button } from 'loyal-react'
import InfiniteScroll from 'react-infinite-scroller'

// #region IMPORT IMG
import Ubook from '@loyal_images/brand/cards-benefits/img_ubook.png'
import DrogariaSP from '@loyal_images/brand/cards-benefits/img_drogaria_sp.png'
import DrogariaPacheco from '@loyal_images/brand/cards-benefits/img_drogaria_pacheco.png'
import Dasa from '@loyal_images/brand/cards-benefits/img_dasa.png'
import Farmadelivery from '@loyal_images/brand/cards-benefits/img_farma_delivery.png'
import ChinaInBox from '@loyal_images/brand/cards-benefits/img_chinainbox.png'
import Mistral from '@loyal_images/brand/cards-benefits/img_mistral.png'
import PicMe from '@loyal_images/brand/cards-benefits/img_picme.png'
import Havanna from '@loyal_images/brand/cards-benefits/img_havanna.png'
import Evino from '@loyal_images/brand/cards-benefits/img_evino.png'
import Centauro from '@loyal_images/brand/cards-benefits/img_centauro.png'
import Netshoes from '@loyal_images/brand/cards-benefits/img_netshoes.png'
import Marisa from '@loyal_images/brand/cards-benefits/img_marisa.png'
import Renner from '@loyal_images/brand/cards-benefits/img_renner.png'
import Shoestock from '@loyal_images/brand/cards-benefits/img_shoestock.png'
import StudioGeek from '@loyal_images/brand/cards-benefits/img_studio_geek.png'
import Zattini from '@loyal_images/brand/cards-benefits/img_zattini.png'
import Petz from '@loyal_images/brand/cards-benefits/img_pets.png'
import GiulianaFlores from '@loyal_images/brand/cards-benefits/img_giuliana_flores.png'
import CestasMichelli from '@loyal_images/brand/cards-benefits/img_cestas_michelli.png'
import NovaFlor from '@loyal_images/brand/cards-benefits/img_nova_flor.png'
import Sony from '@loyal_images/brand/cards-benefits/img_sony.png'
import Nespresso from '@loyal_images/brand/cards-benefits/img_nespresso.png'
import Decolar from '@loyal_images/brand/cards-benefits/img_decolar.png'
import Conectcar from '@loyal_images/brand/cards-benefits/img_conectcar.png'
import HoteisCom from '@loyal_images/brand/cards-benefits/img_hoteis.png'
import Localiza from '@loyal_images/brand/cards-benefits/img_localiza.png'
import Movida from '@loyal_images/brand/cards-benefits/img_movida.png'
import Natura from '@loyal_images/brand/cards-benefits/img_natura.png'
import Unidas from '@loyal_images/brand/cards-benefits/img_unidas.png'
import Hertz from '@loyal_images/brand/cards-benefits/img_hertz.png'
import MenuPersonnalite from '@loyal_images/brand/cards-benefits/img_menu_personnalite.png'
import SociedadeMesa from '@loyal_images/brand/cards-benefits/img_sociedade_mesa.png'
import Orfeu from '@loyal_images/brand/cards-benefits/img_cafeorfeu.png'
import Wine from '@loyal_images/brand/cards-benefits/img_wine.png'
import LesGourmands from '@loyal_images/brand/cards-benefits/img_lesgourmand.png'
import MOB from '@loyal_images/brand/cards-benefits/img_mob.png'
import AMARO from '@loyal_images/brand/cards-benefits/img_amaro.png'
import LoungePersonnalite from '@loyal_images/brand/cards-benefits/img_lounge_personnalite.png'
import OSESP from '@loyal_images/brand/cards-benefits/img_serie_osesp.png'
import Cinema from '@loyal_images/brand/cards-benefits/img_cinema.png'
import Teatro from '@loyal_images/brand/cards-benefits/img_teatro.png'
import LivUp from '@loyal_images/brand/cards-benefits/img_livup.png'
import EmporioNestle from '@loyal_images/brand/cards-benefits/img_emporio_nestle.png'
import Aramis from '@loyal_images/brand/cards-benefits/img_aramis.png'
import Extra from '@loyal_images/brand/cards-benefits/img_extra.png'
import PontoFrio from '@loyal_images/brand/cards-benefits/img_pontofrio.png'
import CasasBahia from '@loyal_images/brand/cards-benefits/img_casasbahia.png'
import ShopClub from '@loyal_images/brand/cards-benefits/img_shopclub.png'
import Loccitane from '@loyal_images/brand/cards-benefits/img_loccitane.png'
import Magalu from '@loyal_images/brand/cards-benefits/img_magalu.png'
import Reserva from '@loyal_images/brand/cards-benefits/img_reserva.png'

// #endregion

class ItauCardListing extends BaseListing {
  componentDidMount () {
    this.benefits = [
      // #region ITAUCARD
      {
        link:
         'https://www.giulianaflores.com.br/?partner=top_itaucardhiperc15&utm_source=itau&utm_medium=parcerias&utm_campaign=perene',
        name: 'Giuliana Flores',
        discount: 15,
        image: GiulianaFlores,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Giuliana Flores',
        title: 'Vai para Giuliana Flores',
        alt: 'Giuliana Flores',
        titleImg: 'Imagem Giuliana Flores'
      },
      {
        link:
          'https://www.novaflor.com.br/?partner=top_itaucardhiperc15&utm_source=itau&utm_medium=parcerias&utm_campaign=perene',
        name: 'Nova Flor',
        discount: 15,
        image: NovaFlor,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Para você',
        partner: 'Nova Flor',
        title: 'Vai para Nova Flor',
        alt: 'Nova Flor',
        titleImg: 'Imagem Nova Flor'
      },
      {
        link: 'http://try.ubook.com/itaucard',
        name: 'Ubook',
        discount: 0,
        image: Ubook,
        descriptionHtml: <span>3 meses por R$14,90</span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Ubook',
        title: 'Vai para Ubook',
        alt: 'Ubook',
        titleImg: 'Imagem Ubook'
      },
      {
        link: 'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',
        name: 'Drogaria São Paulo',
        discount: 35,
        image: DrogariaSP,
        descriptionHtml: <span>Até 35% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Nutrição e Saúde',
        partner: 'Drogaria São Paulo',
        title: 'Vai para Drogaria São Paulo',
        alt: 'Drogaria São Paulo',
        titleImg: 'Imagem Drogaria São Paulo'
      },
      {
        link: 'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',
        name: 'Drogaria Pacheco',
        discount: 35,
        image: DrogariaPacheco,
        descriptionHtml: <span>Até 35% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Nutrição e Saúde',
        partner: 'Drogaria Pacheco',
        title: 'Vai para Drogaria Pacheco',
        alt: 'Drogaria Pacheco',
        titleImg: 'Imagem Drogaria Pacheco'
      },
      {
        link: 'https://dasa.com.br/parcerias/itau',
        name: 'Dasa',
        discount: 25,
        image: Dasa,
        descriptionHtml: <span>Até 25% de descontos em exames</span>,
        profile: 'quem tem Itaucard',
        category: 'Nutrição e Saúde',
        partner: 'Dasa',
        title: 'Vai para Dasa',
        alt: 'Dasa',
        titleImg: 'Imagem Dasa'
      },
      {
        link: 'https://itaucard.farmadelivery.com.br',
        name: 'Farmadelivery',
        discount: 12,
        image: Farmadelivery,
        descriptionHtml: <span>Até 12% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Nutrição e Saúde',
        partner: 'Farmadelivery',
        title: 'Vai para Farmadelivery',
        alt: 'Farmadelivery',
        titleImg: 'Imagem Farmadelivery'
      },
      {
        link: 'https://www.chinainbox.com.br',
        name: 'China In Box',
        discount: 15,
        image: ChinaInBox,
        descriptionHtml: <span>15% off com cupom 15ITAUCHINA. Min R$30</span>,
        profile: 'quem tem Itaucard',
        category: 'Alimentos',
        partner: 'China In Box',
        title: 'Vai para China In Box',
        alt: 'China In Box',
        titleImg: 'Imagem China In Box'
      },
      {
        link: 'https://www.clubepicme.com.br/itaucard',
        name: 'Pic-Me',
        discount: 20,
        image: PicMe,
        descriptionHtml: <span>20% off nas assinaturas</span>,
        profile: 'quem tem Itaucard',
        category: 'Alimentos',
        partner: 'Pic-Me',
        title: 'Vai para Pic-Me',
        alt: 'Pic-Me',
        titleImg: 'Imagem Pic-Me'
      },
      {
        link: 'http://www.havanna.com.br',
        name: 'Havanna',
        discount: 20,
        image: Havanna,
        descriptionHtml: <span>20% off com o cupom ITAUCARD2020</span>,
        profile: 'quem tem Itaucard',
        category: 'Alimentos',
        partner: 'Havanna',
        title: 'Vai para Havanna',
        alt: 'Havanna',
        titleImg: 'Imagem Havanna'
      },
      {
        link: 'https://www.mistral.com.br/parceria/itaucard',
        name: 'Mistral',
        discount: 20,
        image: Mistral,
        descriptionHtml: <span>Seleção de vinhos com Até 20%</span>,
        profile: 'quem tem Itaucard',
        category: 'Bebidas',
        partner: 'Mistral',
        title: 'Vai para Mistral',
        alt: 'Mistral',
        titleImg: 'Imagem Mistral'
      },
      {
        link: 'https://www.evino.com.br',
        name: 'Evino',
        discount: 10,
        image: Evino,
        descriptionHtml: <span>10% off com o cupom 10iupp</span>,
        profile: 'pra todo mundo',
        category: 'Bebidas',
        partner: 'Evino',
        title: 'Vai para Evino',
        alt: 'Evino',
        titleImg: 'Imagem Evino'
      },
      {
        link: 'https://www.nespressobenefits.com.br/',
        name: 'Nespresso',
        discount: 20,
        image: Nespresso,
        descriptionHtml: <span>20% off com o cupom it0615</span>,
        profile: 'quem tem Itaucard',
        category: 'Bebidas',
        partner: 'Nespresso',
        title: 'Vai para Nespresso',
        alt: 'Nespresso',
        titleImg: 'Imagem Nespresso'
      },
      {
        link: 'https://itau.centauro.com.br',
        name: 'Centauro',
        discount: 15,
        image: Centauro,
        descriptionHtml: <span>15% de desconto no site</span>,
        profile: 'quem tem Itaucard',
        category: 'Esporte',
        partner: 'Centauro',
        title: 'Vai para Centauro',
        alt: 'Centauro',
        titleImg: 'Imagem Centauro'
      },
      {
        link: 'https://clube.netshoes.com.br/especial/itaucard?campaign=netpro_b2b_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard',
        name: 'Netshoes',
        discount: 15,
        image: Netshoes,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Esporte',
        partner: 'Netshoes',
        title: 'Vai para Netshoes',
        alt: 'Netshoes',
        titleImg: 'Imagem Netshoes'
      },
      {
        link: 'https://www.marisa.com.br/parcerias/c/itaucard',
        name: 'Marisa',
        discount: 15,
        image: Marisa,
        descriptionHtml: <span>15% de desconto nas compras acima de R$200</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Marisa',
        title: 'Vai para Marisa',
        alt: 'Marisa',
        titleImg: 'Imagem Marisa'
      },
      {
        link:
          'https://clube.lojasrenner.com.br/b2b/itaucard?partner=itaucard&utm_campaign=itaucard&utm_source=b2b&utm_medium=itaucard',
        name: 'Renner',
        discount: 15,
        image: Renner,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Renner',
        title: 'Vai para Renner',
        alt: 'Renner',
        titleImg: 'Imagem Renner'
      },
      {
        link:
          'https://www.shoestock.com.br/especial/itaucard?campaign=netpro_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard',
        name: 'Shoestock',
        discount: 15,
        image: Shoestock,
        descriptionHtml: <span>15% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Shoestock',
        title: 'Vai para Shoestock',
        alt: 'Shoestock',
        titleImg: 'Imagem Shoestock'
      },
      {
        link: 'https://www.studiogeek.com.br',
        name: 'Studio Geek',
        discount: 20,
        image: StudioGeek,
        descriptionHtml: <span>20% off com o cupom ITAUCARD</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Studio Geek',
        title: 'Vai para Studio Geek',
        alt: 'Studio Geek',
        titleImg: 'Imagem Studio Geek'
      },
      {
        link: 'https://www.zattini.com.br/especial/itaucard?campaign=netpro_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard',
        name: 'Zattini',
        discount: 15,
        image: Zattini,
        descriptionHtml: <span>15% off</span>,
        profile: 'quem tem Itaucard',
        category: 'Moda',
        partner: 'Zattini',
        title: 'Vai para Zattini',
        alt: 'Zattini',
        titleImg: 'Imagem Zattini'
      },
      {
        link: 'https://petz.parceriasonline.com.br/itaucard',
        name: 'Petz',
        discount: 10,
        image: Petz,
        descriptionHtml: <span>10% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Pet',
        partner: 'Petz',
        title: 'Vai para Petz',
        alt: 'Petz',
        titleImg: 'Imagem Petz'
      },
      {
        link: 'https://corporativostore.sony.com.br/itau',
        name: 'Sony',
        discount: 15,
        image: Sony,
        descriptionHtml: <span>Até 15% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Sony',
        title: 'Vai para Sony',
        alt: 'Sony',
        titleImg: 'Imagem Sony'
      },
      {
        link: 'https://clube2.magazineluiza.com.br/itau',
        name: 'Magalu',
        discount: 10,
        image: Magalu,
        descriptionHtml: <span>Até 10% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Magalu',
        title: 'Vai para Magalu',
        alt: 'Magalu',
        titleImg: 'Imagem Magalu'
      },
      {
        link:
          'https://itaucard.decolar.com/login?redirect_to=%2Fwhitelabel%2Fsocial%2Flogin%3Fredirect_to%3Dhttps%253A%252F%252Fitaucard.decolar.com%252Fhome',
        name: 'Decolar',
        discount: 10,
        image: Decolar,
        descriptionHtml: <span>Até 10% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Decolar',
        title: 'Vai para Decolar',
        alt: 'Decolar',
        titleImg: 'Imagem Decolar'
      },
      {
        link: 'https://parceiros.conectcar.com/ofertas-itaucard/',
        name: 'Conectcar',
        discount: 30,
        image: Conectcar,
        descriptionHtml: <span>12 mensalidades grátis no Plano Completo</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Conectcar',
        title: 'Vai para Conectcar',
        alt: 'Conectcar',
        titleImg: 'Imagem Conectcar'
      },
      {
        link:
          'https://www.hoteis.com/ofertas-de-hoteis/descontos-itaucard?locale=pt_BR&pos=HCOM_BR&rffrid=mdp.hcom.br.404.000.00.00',
        name: 'Hoteis.com',
        discount: 10,
        image: HoteisCom,
        descriptionHtml: <span>10% de desconto.</span>,
        profile: 'quem tem Itaucard',
        category: 'Hotelaria',
        partner: 'Hoteis.com',
        title: 'Vai para Hoteis.com',
        alt: 'Hoteis.com',
        titleImg: 'Imagem Hoteis.com'
      },
      {
        link: 'https://www.localizahertz.com/brasil/pt-br/ofertas/itaucard',
        name: 'Localiza',
        discount: 15,
        image: Localiza,
        descriptionHtml: <span>15% off + parcelamento em 10x s/ juros</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Localiza',
        title: 'Vai para Localiza',
        alt: 'Localiza',
        titleImg: 'Imagem Localiza'
      },
      {
        link: 'https://parcerias.movida.com.br/itaucard',
        name: 'Movida',
        discount: 10,
        image: Movida,
        descriptionHtml: <span>10% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Transporte',
        partner: 'Movida',
        title: 'Vai para Movida',
        alt: 'Movida',
        titleImg: 'Imagem Movida'
      },
      {
        link: 'https://www.natura.com.br/parceiros/itaucard',
        name: 'Natura',
        discount: 10,
        image: Natura,
        descriptionHtml: <span>10% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Perfumaria',
        partner: 'Natura',
        title: 'Vai para Natura',
        alt: 'Natura',
        titleImg: 'Imagem Natura'
      },
      // #endregion

      // #region PERSONNALITE
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/movida/',
        name: 'Movida',
        discount: 15,
        image: Movida,
        descriptionHtml: <span>Até 15% off sobre a diária dos carros</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Movida',
        title: 'Vai para Movida',
        alt: 'Movida',
        titleImg: 'Imagem Movida'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/decolar/',
        name: 'Decolar',
        discount: 12,
        image: Decolar,
        descriptionHtml: <span>Até 12% de desconto</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Decolar',
        title: 'Vai para Decolar',
        alt: 'Decolar',
        titleImg: 'Imagem Decolar'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/viagem/unidas/',
        name: 'Unidas',
        discount: 25,
        image: Unidas,
        descriptionHtml: <span>Descontos de Até 25%</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Unidas',
        title: 'Vai para Unidas',
        alt: 'Unidas',
        titleImg: 'Imagem Unidas'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/viagem/hertz/',
        name: 'Hertz',
        discount: 20,
        image: Hertz,
        descriptionHtml: <span>20% de desconto na locação de veículos</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Hertz',
        title: 'Vai para Hertz',
        alt: 'Hertz',
        titleImg: 'Imagem Hertz'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/viagem/localiza/',
        name: 'Localiza Hertz',
        discount: 22,
        image: Localiza,
        descriptionHtml: <span>Até 22% off (sobre o valor das diárias)</span>,
        profile: 'pra quem é Personnalité',
        category: 'Viagem',
        partner: 'Localiza Hertz',
        title: 'Vai para Localiza Hertz',
        alt: 'Localiza Hertz',
        titleImg: 'Imagem Localiza Hertz'
      },
      {
        link: 'https://www.ibeneficios.com.br/menupersonnalite',
        name: 'Menu Personnalité',
        discount: 0,
        image: MenuPersonnalite,
        descriptionHtml: <span>Um menu desgustação exclusivo</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Menu Personnalité',
        title: 'Vai para Menu Personnalité',
        alt: 'Menu Personnalité',
        titleImg: 'Imagem Menu Personnalité'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/',
        name: 'Sociedade da mesa',
        discount: 0,
        image: SociedadeMesa,
        descriptionHtml: <span>Faça parte do Clube de vinhos</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Sociedade da mesa',
        title: 'Vai para Sociedade da mesa',
        alt: 'Sociedade da mesa',
        titleImg: 'Imagem Sociedade da mesa'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/nespresso',
        name: 'Nespresso',
        discount: 25,
        image: Nespresso,
        descriptionHtml: <span>Até 25% off em máquinas selecionadas</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Nespresso',
        title: 'Vai para Nespresso',
        alt: 'Nespresso',
        titleImg: 'Imagem Nespresso'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/mistral',
        name: 'Mistral',
        discount: 25,
        image: Mistral,
        descriptionHtml: <span>Até 25% de desconto em quase 600 rótulos</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Mistral',
        title: 'Vai para Mistral',
        alt: 'Mistral',
        titleImg: 'Imagem Mistral'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/gastronomia/cafe-orfeu/',
        name: 'Orfeu',
        discount: 20,
        image: Orfeu,
        descriptionHtml: <span>20% de desconto em todos os cafés do site</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Orfeu',
        title: 'Vai para Orfeu',
        alt: 'Orfeu',
        titleImg: 'Imagem Orfeu'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/gastronomia/wine/',
        name: 'Wine',
        discount: 15,
        image: Wine,
        descriptionHtml: <span>15% de desconto em todas as mensalidades</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Wine',
        title: 'Vai para Wine',
        alt: 'Wine',
        titleImg: 'Imagem Wine'
      },
      {
        link:
          'https://www.itau.com.br/personnalite/experiencia/gastronomia/les-gourmands-club',
        name: 'Les Gourmands',
        discount: 20,
        image: LesGourmands,
        descriptionHtml: <span>20% na 1º mensalidade + 10% no resto</span>,
        profile: 'pra quem é Personnalité',
        category: 'Gastronomia',
        partner: 'Les Gourmands',
        title: 'Vai para Les Gourmands',
        alt: 'Les Gourmands',
        titleImg: 'Imagem Les Gourmands'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/mob/',
        name: 'MOB',
        discount: 30,
        image: MOB,
        descriptionHtml: <span>30% off em compras pelo site</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida ',
        partner: 'MOB',
        title: 'Vai para MOB',
        alt: 'MOB',
        titleImg: 'Imagem MOB'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/amaro/',
        name: 'AMARO',
        discount: 15,
        image: AMARO,
        descriptionHtml: <span>15% + frete grátis compras maior de R$199,00</span>,
        profile: 'pra quem é Personnalité',
        category: 'Estilo de Vida ',
        partner: 'AMARO',
        title: 'Vai para AMARO',
        alt: 'AMARO',
        titleImg: 'Imagem AMARO'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/cultura/lounge',
        name: 'Lounge Personnalité',
        discount: 0,
        image: LoungePersonnalite,
        descriptionHtml: <span>Louge Personnalité: Programação Especial</span>,
        profile: 'pra quem é Personnalité',
        category: 'Cultura',
        partner: 'Lounge Personnalité',
        title: 'Vai para Lounge Personnalité',
        alt: 'Lounge Personnalité',
        titleImg: 'Imagem Lounge Personnalité'
      },
      {
        link: 'https://www.itau.com.br/personnalite/experiencia/cultura/osesp',
        name: 'Osesp',
        discount: 0,
        image: OSESP,
        descriptionHtml: <span>Série OSESP Personnalité</span>,
        profile: 'pra quem é Personnalité',
        category: 'Cultura',
        partner: 'Osesp',
        title: 'Vai para Osesp',
        alt: 'Osesp',
        titleImg: 'Imagem Osesp'
      },
      {
        link: 'https://www.itau.com.br/cartoes/beneficios/cinema/',
        name: 'Cinema',
        discount: 50,
        image: Cinema,
        descriptionHtml: <span>50% de desconto</span>,
        profile: 'pra quem é Personnalité',
        category: 'Cultura',
        partner: 'Cinema',
        title: 'Vai para Cinema',
        alt: 'Cinema',
        titleImg: 'Imagem Cinema'
      },
      {
        link: 'https://www.itau.com.br/cartoes/beneficios/cinema/',
        name: 'Cinema',
        discount: 50,
        image: Cinema,
        descriptionHtml: <span>50% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Cinema',
        title: 'Vai para Cinema',
        alt: 'Cinema',
        titleImg: 'Imagem Cinema'
      },
      {
        link: 'https://www.itau.com.br/cartoes/beneficios/teatro/',
        name: 'Teatro',
        discount: 50,
        image: Teatro,
        descriptionHtml: <span>Até 50% de desconto</span>,
        profile: 'pra quem é Personnalité',
        category: 'Cultura',
        partner: 'Teatro',
        title: 'Vai para Teatro',
        alt: 'Teatro',
        titleImg: 'Imagem Teatro'
      },
      {
        link: 'https://www.itau.com.br/cartoes/beneficios/teatro/',
        name: 'Teatro',
        discount: 50,
        image: Teatro,
        descriptionHtml: <span>Até 50% de desconto</span>,
        profile: 'quem tem Itaucard',
        category: 'Entretenimento',
        partner: 'Teatro',
        title: 'Vai para Teatro',
        alt: 'Teatro',
        titleImg: 'Imagem Teatro'
      },
      // #endregion

      // #region IUPP
      {
        link:
          'https://www.livup.com.br/nosso-cardapio?utm_source=projetos&utm_medium=empresas&utm_campaign=itau',
        name: 'Liv up',
        discount: 10,
        image: LivUp,
        descriptionHtml: <span>10% off com o cupom IUPP 10</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Liv up',
        title: 'Vai para Liv up',
        alt: 'Liv up',
        titleImg: 'Imagem Liv up'
      },
      {
        link: 'http://emporionestle.parceriasonline.com.br/iupp',
        name: 'Empório Nestlé',
        discount: 10,
        image: EmporioNestle,
        descriptionHtml: <span>10% em todos os produtos da loja</span>,
        profile: 'pra todo mundo',
        category: 'Alimentos',
        partner: 'Empório Nestlé',
        title: 'Vai para Empório Nestlé',
        alt: 'Empório Nestlé',
        titleImg: 'Imagem Empório Nestlé'
      },
      {
        link: 'https://www.aramis.com.br/',
        name: 'Aramis',
        discount: 15,
        image: Aramis,
        descriptionHtml: <span>15% off com o cupom iupp15</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Aramis',
        title: 'Vai para Aramis',
        alt: 'Aramis',
        titleImg: 'Imagem Aramis'
      },
      {
        link: 'https://www.extra.com.br/loja/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',
        name: 'Extra',
        discount: 25,
        image: Extra,
        descriptionHtml: <span>Até 25% em produtos selecionados</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Extra',
        title: 'Vai para Extra',
        alt: 'Extra',
        titleImg: 'Imagem Extra'
      },
      {
        link: 'https://www.pontofrio.com.br/b2b/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',
        name: 'Ponto Frio',
        discount: 25,
        image: PontoFrio,
        descriptionHtml: <span>Até 25% em produtos selecionados</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Ponto Frio',
        title: 'Vai para Ponto Frio',
        alt: 'Ponto Frio',
        titleImg: 'Imagem Ponto Frio'
      },
      {
        link: 'https://www.casasbahia.com.br/loja/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',
        name: 'Casas Bahia',
        discount: 25,
        image: CasasBahia,
        descriptionHtml: <span>Até 25% em produtos selecionados</span>,
        profile: 'quem tem Itaucard',
        category: 'Eletroeletrônicos',
        partner: 'Casas Bahia',
        title: 'Vai para Casas Bahia',
        alt: 'Casas Bahia',
        titleImg: 'Imagem Casas Bahia'
      },
      {
        link:
          'https://www.shopclub.com.br/iupp',
        name: 'ShopClub',
        discount: 45,
        image: ShopClub,
        descriptionHtml: <span>Até 40% off com o cupom iupp</span>,
        profile: 'pra todo mundo',
        category: 'Eletroeletrônicos',
        partner: 'ShopClub',
        title: 'Vai para ShopClub',
        alt: 'ShopClub',
        titleImg: 'Imagem ShopClub'
      },
      {
        link: 'https://loccitane.parceriasonline.com.br/iupp',
        name: `L'occitane`,
        discount: 15,
        image: Loccitane,
        descriptionHtml: <span>15% off com o cupom IUPP2020</span>,
        profile: 'pra todo mundo',
        category: 'Perfumaria',
        partner: `L'occitane`,
        title: 'Vai para loccitane',
        alt: 'loccitane',
        titleImg: 'Imagem loccitane'
      },
      {
        link: 'https://www.reserva.ink/iupp',
        name: 'Reserva',
        discount: 0,
        image: Reserva,
        descriptionHtml: <span>Camisetas personalizadas iupp por R$79,00</span>,
        profile: 'pra todo mundo',
        category: 'Moda',
        partner: 'Reserva',
        title: 'Vai para reserva',
        alt: 'reserva',
        titleImg: 'Imagem reserva'
      },
      {
        link: 'https://www.cestasmichelli.com.br/cestas-de-presente-dia-dos-pais/gdiapais/?partner=top_iupp25diadospais&utm_source=iupp&utm_medium=parcerias&utm_campaign=diadospais',
        name: 'Cestas Michelli',
        discount: 25,
        image: CestasMichelli,
        descriptionHtml: <span>25% off </span>,
        profile: 'pra todo mundo',
        category: 'Para você',
        partner: 'Cestas Michelli',
        title: 'Vai para Cestas Michelli',
        alt: 'Cestas Michelli',
        titleImg: 'Imagem Cestas Michelli'
      }
      // #endregion
    ]

    this.buildFilters(this.benefits)
    this.filterBenefits()
    this.onOrderChange({ type: 'ASCENDING' })
  }

  render () {
    return (
      <Fragment>
        <div className='container-fluid px-0 d-flex justify-content-center'>
          <div className='container row px-0 pt-2 pb-3'>
            <div className='col-12 mt-2 d-block d-md-none'>
              <Button
                text='Filtrar'
                iconName='icon_filter'
                className={`col-12 btn-sm ${this.state.openFilter ? 'd-none' : ''}`}
                onClick={() => this.setState({ openFilter: true })}
              />
              <Button
                text='Voltar'
                iconName='icon_left icon-sm pt-3'
                className={`col-12 btn-sm btn-flat pt-5 ${this.state.openFilter ? '' : 'd-none'}`}
                onClick={() => this.setState({ openFilter: false })}
              />
              <div
                className={`float-button bg-white px-2 py-2 row mx-0 ${this.state.openFilter ? '' : 'd-none'}`}
              >
                <div className='col-12 px-0'>
                  <Button
                    className='btn btn-sm btn-featured'
                    text='Aplicar'
                    onClick={() => this.setState({ openFilter: false })}
                  />
                </div>
              </div>
              <div className={`col-12 ${this.state.openFilter ? '' : 'd-none'}`}>
                <Filter onOrderChange={this.onOrderChange} onFilterChange={this.onFilterChange} filters={this.state.filter} profiles={this.state.profiles} categories={this.state.categories} places={this.state.places} partners={this.state.partners} tags={this.state.tags} removeTags={this.removeTags} removeAllTags={this.removeAllTags} />
              </div>
            </div>
            <div className='col-3 mt-2 d-none d-md-block'>
              <Filter onOrderChange={this.onOrderChange} onFilterChange={this.onFilterChange} filters={this.state.filter} profiles={this.state.profiles} categories={this.state.categories} places={this.state.places} partners={this.state.partners} tags={this.state.tags} removeTags={this.removeTags} removeAllTags={this.removeAllTags} />
            </div>
            <div
              className={`col-12 col-md-9 mt-2 row parters-benefits-area mx-0 px-0 ${this.state.openFilter ? 'd-none' : ''}`}
            >
              <InfiniteScroll
                initialLoad={false}
                pageStart={0}
                loadMore={this.loadItems}
                hasMore={this.hasMoreItems}
                loader={
                  <Button loading text='Carregando' className='btn-flat' />
                }
                className='container row mx-0 px-0'
              >
                <div className='row col-12 mx-0 px-0'>
                  {this.state.filteredBenefits && this.state.filteredBenefits.map(this.getCardsBenefits)}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default ItauCardListing



// WEBPACK FOOTER //
// ./src/features/Benefits/Listing/ItauCardListing.js